export default "__VITE_ASSET__CByT5erF__"